import react, { useContext, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridColDef, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, GridValueGetterParams, } from "@mui/x-data-grid";
import styled from "styled-components";
import { Typography, Button, Checkbox, Fab, Paper, IconButton, Stack, Tab, Tabs, CircularProgress, Dialog, DialogActions, DialogContent, TextField, DialogTitle, MenuItem, Select, Modal, FormControl, InputLabel, Autocomplete } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { CloseOutlined } from "@mui/icons-material";
import { Add, Save, SaveAlt } from "@mui/icons-material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CloseIcon from '@mui/icons-material/Close';
import OrderLineItemModal from "../../components/modals/orderLineItemModal";
import clearFilterImage from "../../icons/clearFilter.svg"
import searchIcon from "../../icons/searchIcon.svg"
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import AddOrderModal from "../../components/modals/addOrder";
import Link from '@mui/material/Link';
import { saveAs } from 'file-saver';
import MergePartyModal from "../../components/modals/MergePartyModal";
const isMobile = window.innerWidth < 900;
const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile &&
    `
      position: relative;
      `}
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${isMobile ? "flex-start" : "space-between"};
  margin-bottom: 10px;
  flex-direction: ${isMobile ? "column" : "row"};
`;
const TableContainer = styled.div`
// height: calc(
//   100vh - ${isMobile ? "56px - 20px - 82.23px" : "132px - 28px - 49.77px"}
// );
  width: 100%;
  // border: solid 1px lightGrey;
  border-radius: 8px;
`;
const DataGridContainer = styled.div`
  max-width: 100%; /* Add this line to limit the width */
  margin: 0 auto; /* Center the content horizontally */
  height: 100%;
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
  display: ${isMobile ? 'flex' : 'grid'};

  ${isMobile &&
    `
    flex-direction: column;
  `}
`;
export default function MergeParty() {
    const label = { inputProps: { "aria-label": "Checkbox demo" } };
    const [loading, setLoading] = useState(false);
    const [accessChanges, setAccessChanges] = useState([]);
    const [rm, setRm] = useState("")
    const [rsm, setRsm] = useState("")
    const [asm, setAsm] = useState("")
    const [rsms, setRsms] = useState([]);
    const [expenseModalData, setExpenseModalData] = useState({});
    const [openExpenseViewModal, setOpenExpenseViewModal] = useState(false);
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
    const [rowCount, setRowCount] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [allUsers, setAllUsers] = useState([]);
    const [asms, setAsms] = useState([]);
    const [rms, setRms] = useState([]);
    const [paginationModel, setPaginationModel] = useState({ page: currentPage - 1, pageSize: 20 });
    const [mergePartyModalOpen, setMergePartyModalOpen] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [sessions, setSessions] = useState([]); // from API
    const [selectedSession, setSelectedSession] = useState("");
    const [isDateRangeDisabled, setIsDateRangeDisabled] = useState(false);
    const [isSessionDisabled, setIsSessionDisabled] = useState(false);
    const [accessModulesData, setAccessModulesData] = useState([]);
    const [filteredDate, setFilteredData] = useState({});

    useEffect(() => {
        if (hasSearched) {
            fetchMergeParty();
        }
    }, [paginationModel.page, paginationModel.pageSize]);


    useEffect(() => {
        fetchAccessModules();
        fetchSessions();
        if (userData?.role.toLowerCase().includes('admin')) {
            getAllUsers();
        }
        if (userData?.role === 'rsm') {
            getUsers('rsm', userData?.id);
        }
        if (userData?.role === 'asm') {
            getUsers('asm', userData?.id);
        }
    }, []);
    const clearFilters = async () => {
        setLoading(true);
        setStartDate("");
        setEndDate("");
        setRm("");
        setRsm("");
        setIsDateRangeDisabled(false);
        setIsSessionDisabled(false);
        setSelectedSession("");
        setAsm("");
        setRsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'rsm'));
        setRms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'se'));
        setAsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'asm'));
        setPaginationModel((prev) => ({ ...prev, pageSize: 20 }));
        setAccessChanges([]);
        setRowCount(0);
        setLoading(false);
    }

    const fetchMergeParty = async () => {
        setLoading(true);
        try {
            let payload = {
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
                // startDate: startDate,
                // endDate: endDate
          startDate: startDate != '' ? startDate : filteredDate?.startDate,
          endDate: endDate != '' ? endDate : filteredDate?.endDate,
            }
            let results = await window.Platform.database.getMergedParty(payload);
            if (results.status) {
                window.NotificationUtils.showError(results.message);
                setLoading(false);
            }
            else {
                const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
                setRowCount(results?.data1)
                setAccessChanges(jsonArrayWithId);
                setLoading(false);
            }
        } catch (error) {
            console.error(error);
            window.NotificationUtils.showError("Error Fetching Data");
            setLoading(false);
        }
        finally {
            setLoading(false)
        }
    }

    async function getAllUsers() {
        let results = await window.Platform.database.fetchEmployees()
        if (results?.status) {
            window.NotificationUtils.showError(results.message);
            setLoading(false);
            return;
        }
        else {
            setAllUsers(results?.data)
            setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
            setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
            setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
            setLoading(false);
        }
    }

    
         const fetchAccessModules = async () => {
        try {
            setLoading(true);
            let data = {
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                userId : userData?.id,
                moduleId : "zUcusyrskq"
            }
            let results = await window.Platform.database.fetchAccessModules(data);
            if (results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
                setLoading(false);
                return;
            }
            else {
                const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setAccessModulesData(jsonArrayWithId);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false)
        }
    }

    async function getUsers(role, id) {
        if (id != "") {
            let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
            if (role == 'rsm') {
                setAsms(results?.data)
                setRms(results?.data1)
            }
            if (role == 'asm') {
                setRms(results?.data)
            }
        } else {
            if (role == 'rsm') {
                setRm("")
                setAsm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
                setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
            }
            if (role == 'asm') {
                setRm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
            }
        }
    }

    const downloadMergedPartyExcel = async () => {
        setLoading(true);
        try {
            let data = {
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
                // startDate: startDate,
                // endDate: endDate
          startDate: startDate != '' ? startDate : filteredDate?.startDate,
          endDate: endDate != '' ? endDate : filteredDate?.endDate
            }
            let result = await window.Platform.database.exportData("party/downloadMergedPartyExcel",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Merged_Party_${formattedDate}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("Export error:", error);
        }
    }


    const fetchSessions = async () => {
        try {
            setLoading(true);
            const response = await window.Platform.database.getAllSessions();
            // if (response?.data) {
            //     setSessions(response.data);
            // }
            if (response?.status) {
           const filterdData1 = response?.data?.filter((ele, ind) => ele?.action == "active")
            setFilteredData(filterdData1[0])
          }
          else {
            window.NotificationUtils.showError("Something Went Wrong in session")
          }
        } catch (error) {
            console.error("Error fetching sessions:", error);
            window.NotificationUtils.showError("Failed to load sessions");
        } finally {
            setLoading(false);
        }
    };


    const handleOpenExpenseModal = (data) => {
        setExpenseModalData(data)
        setOpenExpenseViewModal(true)
    }

    const handleCloseExpenseViewModal = () => {
        setOpenExpenseViewModal(false);
        setExpenseModalData({})
    };

    const formatTimeStamp = (timestampFromDB) => {
        const options = {
            timeZone: 'Asia/Kolkata',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,  // Use 12-hour clock
        };
        const formattedDate = new Date(timestampFromDB).toLocaleString('en-US', options);

        return formattedDate;
    };

    const getEmployeeColumns = () => {
        let result = [
            {
                field: "name",
                headerName: "Primary Party ID",
                width: 160,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    let name = params.row.primaryPartyId || "";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "partyId1",
                headerName: "Name",
                width: 200,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    let name = params.row.primarySchoolName || "";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "Secondary12party",
                headerName: "Secondary Party ID",
                width: 160,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    let name = params.row.secondaryPartyId || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "secondaryPartyname12",
                headerName: "Name",
                width: 200,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    let name = params.row.secondarySchoolName || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    )
                },
            },
            {
                field: "mergedBy",
                headerName: "Merged By",
                width: 160,
                filterable: true,
                sortable: false,
                valueGetter: (params) => {
                    return (params?.row?.actionByName || "N/A");
                },
                renderCell: (params) => {
                    let name = params.row?.actionByName || "N/A"
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
                        </Tooltip>
                    )
                },
            },
            // {
            //     field: "dateAndTime",
            //     headerName: "Date & Time",
            //     width: 170,
            //     filterable: true,
            //     sortable: false,
            //     valueGetter: (params) => {
            //         // return (params?.row?.Amount || "N/A");
            //          let dateStr = params.row.createdAt;
            //         let name = "N/A";
            //         if (dateStr) {
            //             const dateObj = new Date(dateStr);
            //             name = dateObj.toLocaleString("en-IN", {
            //                 timeZone: "Asia/Kolkata",
            //                 year: "numeric",
            //                 month: "2-digit",
            //                 day: "2-digit",
            //             });
            //         }
            //     },
            //     renderCell: (params) => {
            //         // let name = Number(params.row.Amount)?.toFixed(2) || "N/A"
            //           let dateStr = params.row.createdAt;
            //         let name = "N/A";
            //         if (dateStr) {
            //             const dateObj = new Date(dateStr);
            //             name = dateObj.toLocaleString("en-IN", {
            //                 timeZone: "Asia/Kolkata",
            //                 year: "numeric",
            //                 month: "2-digit",
            //                 day: "2-digit",
            //             });
            //         }
            //         return (
            //             <Tooltip title={name || "N/A"}>
            //                 <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            //             </Tooltip>
            //         )
            //     },
            // },
            {
                field: "dateAndTime",
                headerName: "Date & Time",
                width: 200,
                filterable: true,
                sortable: false,
                valueGetter: (params) => {
                    let dateStr = params.row.createdAt;
                    if (dateStr) {
                        const dateObj = new Date(dateStr);
                        return dateObj.toLocaleString("en-IN", {
                            timeZone: "Asia/Kolkata",
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true, // use false if you want 24h format
                        });
                    }
                    return "N/A";
                },
                renderCell: (params) => {
                    let dateStr = params.row.createdAt;
                    let name = "N/A";
                    if (dateStr) {
                        const dateObj = new Date(dateStr);
                        name = dateObj.toLocaleString("en-IN", {
                            timeZone: "Asia/Kolkata",
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true, // or false for 24h
                        });
                    }
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {name || "N/A"}
                            </Typography>
                        </Tooltip>
                    )
                },
            }

        ];
        return result
    }
    function CustomToolbar() {
        return (
            <GridToolbarContainer className="d-flex justify-content-end align-items-center mr-2">
                <Typography variant="body1" className="ml-4" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
                <Select
                    value={paginationModel.pageSize}
                    variant="outlined"
                    size="small"
                    onChange={(e) => { setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
                    sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}
                >
                    {[10, 20, 30, 50, 100].map((role) => (
                        <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role}</MenuItem>
                    ))}
                </Select>
            </GridToolbarContainer>
        );
    }
    const renderContent = () => {
        return (
            <DataGridContainer style={{ height: !accessChanges?.length ? '200px' : 'auto' }}>
                <DataGrid
                    className="payrollGrid"
                    density="compact"
                    rows={accessChanges}
                    columns={getEmployeeColumns()}
                    sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
                    disableSelectionOnClick
                    disableRowSelectionOnClick
                    rowHeight={60}
                    disableDensitySelector
                    pageSizeOptions={[10]}
                    onFilterModelChange={(val) => {
                        // fetchMergeParty(val)
                    }
                    }
                    filterMode="server"
                    rowCount={rowCount}
                    paginationModel={paginationModel}
                    paginationMode="server"
                    onPaginationModelChange={setPaginationModel}
                    components={{
                        Toolbar: CustomToolbar,
                    }}
                />
            </DataGridContainer>
        );
    }
    return (
        <>
            <StaffEditorPageContainer>
                <HeaderContainer>
                    {loading && <OpaqueLoading />}
                    <Box sx={{ mt: 1, width: "100%" }}>

                        <Paper elevation={3}
                            sx={{
                                p: 2,
                                mb: 2,
                                width: '100%',
                                // maxWidth: '1000px',
                                mx: 'auto',
                                backgroundColor: "#ebf0fa"
                            }}>
                            <div className="container-fluid" style={{ width: "100%" }}>
                                <div className="row mb-2 align-items-end">
                                    {userData?.role.includes('admin') && <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select HO</InputLabel>
                                            <Select label="Select HO" value={rsm} variant="outlined" size="small" onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value); setAsm(""); setRm(""); }} sx={{ width: '100%', fontSize: 14 }}>
                                                <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>All</MenuItem>
                                                {rsms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>{role.name} - {role.username}</MenuItem>))}
                                            </Select>
                                        </FormControl>
                                    </div>}
                                    {userData?.role != 'asm' && <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select ARM</InputLabel>
                                            <Select label="Select ARM" value={asm} variant="outlined" size="small" onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value); setRm(""); }} sx={{ width: '100%', fontSize: 14 }}>
                                                <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>All</MenuItem>
                                                {asms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>{role.name} - {role.username}</MenuItem>))}
                                            </Select>
                                        </FormControl>
                                    </div>}
                                    <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select RM:</InputLabel>
                                            <Select label="Select RM" value={rm} variant="outlined" size="small" onChange={(e) => { setRm(e.target.value); }} sx={{ width: '100%', fontSize: 14 }}>
                                                <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>All</MenuItem>
                                                {rms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>{role.name} - {role.username}</MenuItem>))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                   { accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" &&   <div className="col-md-3">
                                        <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }} onClick={() => { downloadMergedPartyExcel() }}>
                                            Download
                                        </Button>
                                    </div>}
                                </div>
                                <div className="row mt-1">
                                    <div className="col-md-3 mt-2">
                                        <FormControl fullWidth size="small">
                                            <TextField label="From Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }} value={startDate} onChange={(e) => setStartDate(e.target.value)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { color: "black", fontSize: "14px", fontWeight: 500 }
                                                }}
                                                inputProps={{
                                                    style: { color: "black", fontSize: "14px", fontWeight: 500 }
                                                }} />
                                        </FormControl>
                                    </div>
                                    <div className="col-md-3 mt-2">
                                        <FormControl fullWidth size="small">
                                            <TextField label="To Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }} value={endDate} onChange={(e) => setEndDate(e.target.value)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { color: "black", fontSize: "14px", fontWeight: 500 }
                                                }}
                                                inputProps={{
                                                    style: { color: "black", fontSize: "14px", fontWeight: 500 }
                                                }} />
                                        </FormControl>
                                    </div>
                                    <div className="col-md-3">
                                        <Button variant="contained" color="primary" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => { setHasSearched(true); fetchMergeParty() }}>
                                            Find
                                        </Button>
                                    </div>
                                    <div className="col-md-3 mt-2">
                                        <Button variant="contained" color="secondary" startIcon={<img src={clearFilterImage} alt="icon" height={"21"} width={"21"} />} fullWidth sx={{ fontSize: '13px', borderRadius: '10px' }} onClick={() => clearFilters()}>
                                            Clear Filters
                                        </Button>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    {/* <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel
                                                sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                                            >
                                                Select Session
                                            </InputLabel>
                                            <Select
                                                label="Select Session"
                                                value={selectedSession}
                                                disabled={isSessionDisabled}
                                                sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                                                onChange={(e) => {
                                                    const selected = sessions.find((item) => item.id === e.target.value);
                                                    setSelectedSession(e.target.value);

                                                    if (selected) {
                                                        // ✅ Convert UTC → IST (local date)
                                                        const start = new Date(selected.startDate);
                                                        const end = new Date(selected.endDate);

                                                        const startIST = new Date(start.getTime() + (5.5 * 60 * 60 * 1000))
                                                            .toISOString()
                                                            .split("T")[0];
                                                        const endIST = new Date(end.getTime() + (5.5 * 60 * 60 * 1000))
                                                            .toISOString()
                                                            .split("T")[0];

                                                        setStartDate(startIST);
                                                        setEndDate(endIST);

                                                        // ✅ Disable manual date range if session chosen
                                                        setIsDateRangeDisabled(true);
                                                    } else {
                                                        // ✅ If cleared, re-enable date inputs
                                                        setIsDateRangeDisabled(false);
                                                    }
                                                }}

                                            >
                                                <MenuItem value="">
                                                    <em>Select Session</em>
                                                </MenuItem>
                                                {sessions.map((s) => (
                                                    <MenuItem key={s.id} value={s.id}>
                                                        {s.sessionName}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div> */}
                                </div>
                            </div>
                        </Paper>
                        { accessModulesData && accessModulesData[0]?.is_add?.toLowerCase() != "no" &&   <Box display="flex" justifyContent="flex-end" gap={2}>
                            <div className="col-md-4">
                                <Button fullWidth
                                    variant="contained" color="primary"
                                    sx={{
                                        fontSize: '14px',
                                        borderRadius: '10px',
                                        size: 'small',
                                        fullWidth: true,
                                        // backgroundColor: '#c99b00',
                                        // color: 'white',
                                        '&:hover': {
                                            backgroundColor: '#0c029dff',
                                        }
                                    }}
                                    onClick={() => setMergePartyModalOpen(true)}
                                >
                                    Merge Party
                                </Button>
                            </div>
                        </Box>}
                    </Box>
                </HeaderContainer>
                <TableContainer>
                    {renderContent()}
                </TableContainer>
            </StaffEditorPageContainer>

            {mergePartyModalOpen && (
                <MergePartyModal
                    onClose={() => setMergePartyModalOpen(false)}
                    fetchData={() => fetchMergeParty()}
                />
            )}
        </>
    );
}
